import {Injectable} from '@angular/core';
import {DaoGeneric} from '@Services/base/daoService';
import {environment} from '@Env/environment';
import {HttpClient} from '@angular/common/http';
import {FormListRequesters} from './requesters-form.model';
import {Individu} from '@Common/core/services';

@Injectable({providedIn: 'root'})
export class FormListRequestersService extends DaoGeneric<FormListRequesters> {
  private _api = `${environment.baseUrl}/demat/form_list_requesters/`;

  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  getRootUrl(urlApp: string | undefined): string {
    return this._api;
  }
  /**
   * Ajoute ou supprime un membre à un liste de sollicités
   * @param {string} action : action à opérater : ajouter ou supprimer la liste au formulaire
   * @param {number} listId : ID liste sollicité précédemment créée
   * @param memberId
   * @param infosMember
   */
  addOrDeleteRequester(action: 'add' | 'delete', listId: number, memberId: number, infosMember: string) {
    const _url = `${this._api}${listId}/requester/`;
    const _params = this._getUrlHttpParams(new Map([
        ['member', memberId.toString()],
        ['infos_member', infosMember]
    ]));
    const action_add_delete = {
      add: this.httpClient.patch<FormListRequesters>(`${_url}`, null, {params: _params}),
      delete: this.httpClient.delete<FormListRequesters>(`${_url}`, {params: _params}),
    };
    return action_add_delete[action];
  }

  /**
   * Vérifie si un user sollicité apparait déjà à une liste
   * @param {number} listId
   * @param {number} userId
   */
  checkRequesterInList(listId: number, userId: number) {
    const _url = `${this._api}${listId}/check_requester_exist/`;
    const _params = this._getUrlHttpParams(new Map([
      ['user', userId.toString()],
    ]));
    return this.httpClient.get(_url, {params: _params});
  }
}
